"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataQualityDetail = exports.DataStatusHeaderIcon = exports.DataQualityTooltipButton = void 0;
var widgets_1 = require("@tableau/widgets");
var React = require("react");
var SpacesDataStatusHeaderOutline_1 = require("../../../gen-src/icons/SpacesDataStatusHeaderOutline");
var DataQualityIndicatorSharedHelpers_1 = require("../dataQualityIndicators/DataQualityIndicatorSharedHelpers");
var DataQualityStyles_1 = require("../style/DataQualityStyles");
var TypescriptHelpers_1 = require("../utils/TypescriptHelpers");
var DataQualityType_1 = require("./DataQualityType");
/**
 * SCARY NOTE: if this is an "interactive-inline" the ref comes from React.forwardRef()
 * if it's "interactive-icon" the setRef callback is used. When the SharedWidgets team allows forward ref in ButtonWidget, get rid of setRef
 */
exports.DataQualityTooltipButton = React.forwardRef(function DataQualityTooltipButton(props, ref) {
    var _a;
    var inlineAlertProps = {
        testId: props.testId,
        type: props.warningKind === 'severe-warning' ? widgets_1.InlineAlertType.Warning : widgets_1.InlineAlertType.Info,
        children: (_a = props.text) !== null && _a !== void 0 ? _a : props.text
    };
    switch (props.kind) {
        case 'interactive-icon':
            return (React.createElement(widgets_1.ButtonWidget, { style: DataQualityStyles_1.DataQualityStatusIconButtonStyle, title: '', ref: props.setRef, testId: props.testId, onClick: props.onClick, buttonType: widgets_1.ButtonType.IconOutline, getContent: function (s) { return React.createElement(DataQualityIndicatorSharedHelpers_1.DataStatusIcon, { isSevere: props.warningKind === 'severe-warning', hover: s.hover || false }); }, tabIndex: props.tabIndex }));
        case 'interactive-inline':
            return (React.createElement(widgets_1.CompactInlineAlertWidget, __assign({}, inlineAlertProps, { ref: ref, onClick: props.onClick })));
        case 'non-interactive-inline':
            return (React.createElement(widgets_1.CompactInlineAlertWidget, __assign({}, inlineAlertProps)));
        default:
            TypescriptHelpers_1.assertUnreachable(props);
            return React.createElement(React.Fragment, null);
    }
});
function DataStatusHeaderIcon(props) {
    return React.createElement(SpacesDataStatusHeaderOutline_1.SvgSpacesDataStatusHeaderOutline, { className: props.className });
}
exports.DataStatusHeaderIcon = DataStatusHeaderIcon;
function DataQualityDetail(props) {
    var inlineProps = {
        warningKind: props.isSevere ? 'severe-warning' : 'standard-warning',
        testId: DataQualityIndicatorSharedHelpers_1.DataQualityDetailChipId,
        kind: 'non-interactive-inline',
        text: DataQualityType_1.localizeDataQualityTypeName(props.type),
    };
    return (React.createElement(DataQualityStyles_1.DataQualityDetailStyle, null,
        React.createElement(exports.DataQualityTooltipButton, __assign({}, inlineProps)),
        React.createElement(DataQualityIndicatorSharedHelpers_1.DataQualityDetailAsset, { assetName: props.assetName, assetType: props.assetType, assetUrl: props.linksDisabled ? null : props.assetUrl || null }),
        React.createElement(DataQualityIndicatorSharedHelpers_1.DataQualityDetailAuthorElement, __assign({ kind: props.isSevere ? 'severe-warning' : 'standard-warning' }, props)),
        React.createElement(DataQualityIndicatorSharedHelpers_1.DataQualityDetailDateElement, { localizedDate: props.localizedDate }),
        React.createElement(DataQualityIndicatorSharedHelpers_1.DataQualityDetailMessageElement, __assign({}, props))));
}
exports.DataQualityDetail = DataQualityDetail;
//# sourceMappingURL=DataQualityDetail.js.map